export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER';
export const LOGOUT = 'LOGOUT';

export const SET_USER_PERMISSION = 'SET_USER_PERMISSION';

interface LoginAction {
  type: typeof LOGIN;
  payload: {
    email: string;
    password: string;
  };
}

interface RegisterAction {
  type: typeof REGISTER;
  payload: {
    email: string;
    password: string;
  };
}

interface LogoutAction {
  type: typeof LOGOUT;
}

export interface setUserPermision {
  type:typeof SET_USER_PERMISSION;
  payload: any;
};



export type AuthActionTypes = LoginAction | RegisterAction | LogoutAction | setUserPermision;
